(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maxton-vehicle-selector"] && !Shopify.designMode) return;
  try {
    
  const initializeMaxtonVehicleSelectors = (root = document) => {
    root.querySelectorAll('[data-maxton-vehicle-selector]').forEach((selector) => {
      if (selector.dataset.initialized === 'true') return;
      const makeSelect = selector.querySelector('[data-maxton-make]');
      const modelSelect = selector.querySelector('[data-maxton-model]');
      const yearSelect = selector.querySelector('[data-maxton-year]');
      const link = selector.querySelector('[data-maxton-vehicle-link]');
      const dataNodes = selector.querySelectorAll('[data-maxton-fitment-data]');
      const currentTagsNode = selector.querySelector('[data-maxton-current-tags]');
      if (!makeSelect || !modelSelect || !yearSelect || !link || dataNodes.length === 0 || !currentTagsNode) return;

      const fitments = Object.assign(
        {},
        ...Array.from(dataNodes, (node) => JSON.parse(node.textContent || '{}')),
      );
      const currentTags = JSON.parse(currentTagsNode.textContent || '[]') || [];
      const collectionUrl = selector.dataset.collectionUrl;
      const allYearsLabel = selector.querySelector('[data-maxton-all-years]')?.textContent || 'All years';
      const notSpecifiedLabel = selector.querySelector('[data-maxton-not-specified]')?.textContent || 'Year not specified';
      const modelPlaceholder = modelSelect.options[0].textContent;
      const yearPlaceholder = yearSelect.options[0].textContent;
      const tagUrl = (tag) => collectionUrl + '/' + tag.toLowerCase();
      const addOption = (select, label, value) => {
        const option = document.createElement('option');
        option.textContent = label;
        option.value = value;
        select.append(option);
      };
      const setLink = (tag) => {
        link.href = tag ? tagUrl(tag) : collectionUrl;
        link.setAttribute('aria-disabled', tag ? 'false' : 'true');
      };
      const resetSelect = (select, placeholder) => {
        select.replaceChildren();
        addOption(select, placeholder, '');
        select.disabled = true;
      };

      Object.keys(fitments)
        .sort((left, right) => left.localeCompare(right, 'de', { numeric: true }))
        .forEach((make) => addOption(makeSelect, make, make));

      const populateModels = (make, selectedTag = '') => {
        resetSelect(modelSelect, modelPlaceholder);
        resetSelect(yearSelect, yearPlaceholder);
        const makeData = fitments[make];
        if (!makeData) {
          setLink('');
          return;
        }
        modelSelect.disabled = false;
        makeData[1].forEach((model) => addOption(modelSelect, model[0], model[1]));
        modelSelect.value = selectedTag;
        setLink(selectedTag || makeData[0]);
      };

      const populateYears = (make, modelTag, selectedTag = '') => {
        resetSelect(yearSelect, yearPlaceholder);
        const model = fitments[make]?.[1]?.find((item) => item[1] === modelTag);
        if (!model) {
          setLink(fitments[make]?.[0] || '');
          return;
        }
        yearSelect.disabled = false;
        addOption(yearSelect, allYearsLabel, modelTag);
        model[2].forEach((year) => {
          addOption(yearSelect, year[0] === 'not_specified' ? notSpecifiedLabel : year[0], year[1]);
        });
        yearSelect.value = selectedTag || modelTag;
        setLink(yearSelect.value);
      };

      makeSelect.addEventListener('change', () => populateModels(makeSelect.value));
      modelSelect.addEventListener('change', () => populateYears(makeSelect.value, modelSelect.value));
      yearSelect.addEventListener('change', () => setLink(yearSelect.value || modelSelect.value));

      let selectedMake = '';
      let selectedModelTag = '';
      let selectedYearTag = '';
      for (const [make, makeData] of Object.entries(fitments)) {
        if (currentTags.includes(makeData[0])) selectedMake = make;
        for (const model of makeData[1]) {
          if (currentTags.includes(model[1])) {
            selectedMake = make;
            selectedModelTag = model[1];
          }
          for (const year of model[2]) {
            if (currentTags.includes(year[1])) {
              selectedMake = make;
              selectedModelTag = model[1];
              selectedYearTag = year[1];
            }
          }
        }
      }
      if (selectedMake) {
        makeSelect.value = selectedMake;
        populateModels(selectedMake, selectedModelTag);
        if (selectedModelTag) populateYears(selectedMake, selectedModelTag, selectedYearTag);
      } else {
        setLink('');
      }
      selector.dataset.initialized = 'true';
    });
  };

  initializeMaxtonVehicleSelectors();
  document.addEventListener('shopify:section:load', (event) => {
    initializeMaxtonVehicleSelectors(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
